import * as angular from 'angular';

"use strict";
angular.module('scanStationService', []);

export default 'scanStationService'
